import { createFileRoute } from '@tanstack/react-router';

import { VideoStreamPageWidget } from '@features/video/pages/VideoStreamPage/VideoStreamPageWidget';

// Телефон участника: билет в ссылке, вход на сайт не нужен. Клуб и турнир тоже
// в ссылке: по ним телефон без входа узнает турнир и свою запись участника
export const Route = createFileRoute('/stream/$clubId/$tournamentId/$mode/$ticket')({
  component: Page,
});

function Page() {
  const { clubId, tournamentId, mode, ticket } = Route.useParams();
  return (
    <VideoStreamPageWidget
      clubId={clubId}
      tournamentId={tournamentId}
      mode={mode === 'extra' ? 'extra' : 'main'}
      ticket={ticket}
    />
  );
}
